import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { RequestDemoModal } from "./RequestDemoModal";
import { ArrowRight, CheckCircle } from "lucide-react";
const ModernCTA = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const elements = entry.target.querySelectorAll(".reveal");
          elements.forEach((el, index) => {
            setTimeout(() => {
              el.classList.add("active");
            }, index * 100);
          });
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const handleStartCollaborating = () => {
    navigate("/pricing");
  };
  return <section id="pricing" ref={sectionRef} className="py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Main CTA Card */}
          <div className="reveal bg-gradient-to-br from-primary to-saas-navy rounded-2xl p-10 md:p-12 text-white relative overflow-hidden shadow-xl">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 right-0 w-72 h-72 rounded-full bg-white blur-3xl"></div>
              <div className="absolute bottom-0 left-0 w-56 h-56 rounded-full bg-white blur-3xl"></div>
            </div>

            <div className="relative z-10 text-center">
              <h2 className="text-heading-xl mb-4">
                Stop Wrestling with WhatsApp Groups
              </h2>
              <p className="text-white/90 text-body-lg mb-8 max-w-2xl mx-auto leading-relaxed">
                Get organised with a platform built specifically for UK property collaboration.
              </p>
              
              <div className="flex justify-center mb-8">
                <Button size="lg" className="bg-saas-blue text-white hover:bg-saas-blue/90 font-semibold px-8 py-6 text-lg h-auto shadow-lg hover:shadow-xl transition-all group" onClick={handleStartCollaborating}>
                  Get Started Now
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                </Button>
              </div>

              <div className="flex flex-col sm:flex-row justify-center items-center gap-4 md:gap-6 text-body-sm text-white/80">
                <div className="flex items-center gap-2">
                  <CheckCircle className="h-5 w-5" />
                  One account per freehold
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle className="h-5 w-5" />
                  All shareholders included
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle className="h-5 w-5" />
                  No setup fees
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default ModernCTA;